import {Box, styled} from "@mui/material";

export const RiskRowBox = styled(Box)(
  ({theme}) => ({
    display: 'flex',
    gap: '21px 21px',
  })
);